export interface Resolver<T> {
    id: string;
    hasResolved: boolean;
    resolvedObject?: T;

    resolve: (
        onSuccess: (resolvedObject: T) => void,
        onFailure: (errorMessage: string) => void
    ) => any;
    cancel: (token: any) => void;

    asAPromise(): Promise<T>;
}

export class CompletedResolver<T> implements Resolver<T> {
    id: string;
    hasResolved: boolean;
    resolvedObject?: T;

    constructor(id: string, resolvedObject: T) {
        this.id = id;
        this.hasResolved = true;
        this.resolvedObject = resolvedObject;
    }

    resolve(onSuccess: (resolvedObject: T) => void, onFailure: (errorMessage: string) => void) {
        const resolvedObject = this.resolvedObject;
        if (resolvedObject) {
            onSuccess(resolvedObject);
        } else {
            onFailure('Unexpected state, completed resolver is missing an object');
        }
        return this.resolvedObject;
    }
    cancel(token: any) {
        // no-op
    }

    asAPromise() {
        const resolvedObject = this.resolvedObject;
        if (resolvedObject) {
            return Promise.resolve(resolvedObject);
        } else {
            return Promise.reject('Unexpected state, completed resolver is missing an object');
        }
    }
}

export interface UpdatingResolver<T> {
    id: string;
    resolvedObject?: T | string;

    addListener: (onUpdate: (update: T | string) => void) => any;
    cancel: (token: any) => void;
}
